import { isFacebookUserAgent } from "@product/scmp-sdk";
import React from "react";

import { FooterVariant } from "scmp-app/components/app-footer";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import { useCurrentPageType } from "scmp-app/lib/router/hooks";

import BlackAppStoreImage from "./black-app-store.png";
import BlackGooglePlayImage from "./black-google-play.png";
import { Container, Icon, IconContainer, StyledBaseLink, Title } from "./styles";
import WhiteAppStoreImage from "./white-app-store.png";
import WhiteGooglePlayImage from "./white-google-play.png";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
  variant?: FooterVariant.Dark;
};

export const FooterDownloadAppWidget: React.FunctionComponent<Props> = ({
  className,
  onClick,
  variant,
}) => {
  const pageType = useCurrentPageType();
  const renderUrl = (children: JSX.Element, trackingName: string) => (
    <StyledBaseLink
      onClick={() => {
        onClick("https://scmp.onelink.me/3586748601/43f04bbb");

        sendGA4Tracking({
          action: "click",
          category: "footer",
          customized_parameters: {
            link_name: trackingName,
          },
          subcategory: "",
        });
        sendGA4Tracking({
          action: "click",
          category: "appdl",
          customized_parameters: {
            click_type: "download",
            os: trackingName === "App Store" ? "ios" : "android",
            page_type: pageType,
            position: "footer",
            ...(isFacebookUserAgent() && { inapp_browser: "fb" }),
          },
          subcategory: "",
        });
      }}
      pathname="https://scmp.onelink.me/3586748601/43f04bbb"
    >
      {children}
    </StyledBaseLink>
  );

  const appStoreSource =
    variant === FooterVariant.Dark ? WhiteAppStoreImage.src : BlackAppStoreImage.src;
  const googlePlaySource =
    variant === FooterVariant.Dark ? WhiteGooglePlayImage.src : BlackGooglePlayImage.src;

  return (
    <Container className={className}>
      <Title>Read more in the SCMP App</Title>
      <IconContainer>
        {renderUrl(<Icon alt="app store" src={appStoreSource} />, "App Store")}
        {renderUrl(<Icon alt="google play" src={googlePlaySource} />, "Google Play")}
      </IconContainer>
    </Container>
  );
};

FooterDownloadAppWidget.displayName = "FooterDownloadAppWidget";
